import "scripts/templates/page.postpartum-2.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.postpartum-2");
